module.exports = __webpack_public_path__ + "img/stethoscope-1.7e51eefc.svg";